import { notification as antdNotification } from "antd";
import classNames from "classnames";
import React from "react";

import SVGIcon from "../Images/SVGIcon";
import styles from "./style.module.css";

export const showNotification = ({ type = "success", className, dataTestId = "", showCloseIcon = true, ...rest }) => {
  antdNotification[type]({
    ...rest,
    ...(type !== "open" ? { icon: <SVGIcon src={`components/v2/notification/${type}.svg`} /> } : {}),
    closeIcon: showCloseIcon ? <SVGIcon src="components/v2/notification/close.svg" data-testid={dataTestId} /> : null,
    className: classNames(styles.container, className),
  });
};

export default antdNotification;
